import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface DrivewayAndWalksDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const DrivewayAndWalksDescription: React.FC<DrivewayAndWalksDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [drivewayAndWalks, set_drivewayAndWalks] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Driveway and Walks']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Driveway and Walks': [v, b.values?.['Final Structure']?.['Driveway and Walks']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={drivewayAndWalks}
                />
            ) : (
                <TextBox
                    value={drivewayAndWalks}
                    onChange={(value) => set_drivewayAndWalks(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
